// extracted by mini-css-extract-plugin
export default {"title":"index_title_NEt17 clearfix","cur":"index_cur_gkmF7"};